import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import Cookies from 'js-cookie';
import styles from './header-informer.module.scss';

const HeaderInformer = (props: {
  expire?: number;
  isError?: boolean;
  isAlwaysVisible?: boolean;
  text: string[];
  isVisible?: boolean;

  /**
   * Defines different designs of the informer
   *
   * @value {'blue'} Blue bg + white text
   * @value {'purple'} Purple bg + white text
   * @default 'blue'
   */
  color?: 'blue' | 'purple';

  /**
   * Defines different designs of the informer
   *
   * @value {true} Defines styles for marketing goals
   * @value {false} Defines styles for system messages
   * @default false
   */
  isPromo?: boolean;
}) => {
  const [isShow, setIsShow] = useState(false);

  const handleClose = () => {
    setIsShow(false);

    Cookies.set('header-informer', '1', {
      expires: props.expire || 1,
    });

    if (!props.isError) {
      const counter = Cookies.get('header-informer-counter');

      if (counter) {
        if (parseInt(counter, 10) < 2) {
          Cookies.set('header-informer-counter', `${parseInt(counter || '0', 10) + 1}`, {
            expires: 15,
          });
        }
      } else {
        Cookies.set('header-informer-counter', '1', {
          expires: 15,
        });
      }
    }
  };

  useEffect(() => {
    const informer = Cookies.get('header-informer');
    const counter = parseInt(Cookies.get('header-informer-counter'), 10);

    if (
      ((props.isAlwaysVisible || props.isVisible)
      // show if it is error, or it doesn't have cookies
      && (props.isError || !informer))
      // shown not enough times
      && (!counter || (counter && counter < 2))
    ) {
      setIsShow(true);
    }
  }, [props.isVisible, props.isAlwaysVisible]);

  return (
    isShow ? (
      <div
        className={classNames(styles['header-informer'], {
          [styles['is-visible']]: props.isVisible,
          [styles['is-always-visible']]: props.isAlwaysVisible,
          [styles['is-error']]: props.isError,
          [styles['is-promo']]: props.isPromo,
          ...(props.color ? { [styles[props.color]]: true } : {}),
        })}
      >
        {!props.isError ? <button type="button" onClick={handleClose} className={styles.close} /> : null}

        {(props.text || []).map((textItem: string) => (
          <p
            key={textItem}
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: textItem }}
          />
        ))}
      </div>
    ) : null
  );
};

HeaderInformer.defaultProps = {
  expire: 0,
  isAlwaysVisible: false,
  isError: false,
  isVisible: false,
};

export default HeaderInformer;
